export const getDateRange = (filterType) => {
    const now = new Date();
    let startDate, endDate;

    switch (filterType) {
        case "Today": {
            startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
            endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
            break;
        }
        case "Yesterday": {
            const yesterday = new Date(now);
            yesterday.setDate(now.getDate() - 1);
            startDate = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0);
            endDate = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59);
            break;
        }
        case "Last 7 Days": {
            endDate = now;
            startDate = new Date(now);
            startDate.setDate(now.getDate() - 7);
            break;
        }
        case "Last 30 Days": {
            endDate = now;
            startDate = new Date(now);
            startDate.setDate(now.getDate() - 30);
            break;
        }
        case "This Month": {
            startDate = new Date(now.getFullYear(), now.getMonth(), 1);
            endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
            break;
        }
        case "Last Month": {
            // For last month, we subtract 1 from the current month
            const lastMonth = now.getMonth() - 1;
            const year = lastMonth < 0 ? now.getFullYear() - 1 : now.getFullYear();
            const month = (lastMonth + 12) % 12;

            startDate = new Date(year, month, 1, 0, 0, 0);
            endDate = new Date(year, month + 1, 0, 23, 59, 59);
            break;
        }
        case "Life Time": {
            // If you want "Life Time" to mean "no date filter," you can set them to null or earliest possible date

            startDate = new Date("2021-01-02");
            endDate = now; // or far future date
            break;
        }
        // case "Custom Range":
        default:
            break;

    }

    return { startDate, endDate };
}